import axios from 'axios';

import { ref, reactive } from 'vue';

export const userData = reactive({
  teachable_id: '',
  email: '',
});

export function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2 || parts.length > 2) {
    return parts.pop().split(';').shift();
  }
  return '';
}

export const toastsMessages = reactive([]);

export function postMessage(type, title, message) {
  const object = {
    statusBg: type === 'danger' ? 'bg-danger' : 'bg-success',
    statusColor: ' text-white',
    title,
    message,
  };
  toastsMessages.push(object);
  setTimeout(() => {
    toastsMessages.shift();
  }, 5000);
}

export function checkDomainENV() {
  if (process.env.VUE_APP_ENV === 'development') {
    return 'domain=.hexschool.com;path=/;';
  }
  return 'domain=.hexschool.com;path=/;';
}

export function getDiff(date) {
  const timestamp = new Date(date).getTime() / 1000;
  let mistiming = Math.round(new Date() / 1000) - timestamp;
  const postfix = mistiming > 0 ? '前' : '後';
  mistiming = Math.abs(mistiming);
  const timeArray = ['年', '個月', '星期', '天', '小時', '分鐘', '秒'];
  const timeSec = [31536000, 2592000, 604800, 86400, 3600, 60, 1];

  for (let i = 0; i < 7; i += 1) {
    const inm = Math.floor(mistiming / timeSec[i]);
    if (inm !== 0) {
      return `${inm} ${timeArray[i]}${postfix}`;
    }
  }
  return 'error';
}

export const postReviewAPI = (methods, videoId, obj) => new Promise((resolve, reject) => {
  axios[methods](`/v1/video-courses/${videoId}/review`, obj)
    .then((res) => {
      resolve(res);
      window.localStorage.setItem(
        'h_b135a9_review_51cb8',
        JSON.stringify({
          ...obj,
          date: new Date().getTime(),
          courseId: videoId,
        }),
      );
    })
    .catch((error) => {
      reject(error);
    });
});

export const actionPermission = ref(false);
export const checkActionPermission = () => { // true: 可以操作，false: 不可操作
  const tokenType = getCookie('rpg_temp_token_type');
  const isLink = getCookie('rpg_temp_token_is_link');
  const token = getCookie('rpg_temp_token');
  if (tokenType === 'rpg' && isLink === 'true' && token) {
    actionPermission.value = true;
  } else {
    actionPermission.value = false; // 先修改為 true，之後再改回 false
  }
};

export const directToRPGUserSystem = (bind) => {
  window.location.href = `${process.env.VUE_APP_USER_SYSTEM_DOMAIN}/#/login?bind=${bind}&redirectType=teachable&route=${window.location.pathname}/`;
};

// 將 token 存入 cookie
export function saveTokenToCookie(expiration, token, tokenType, isLink) {
  const domain = checkDomainENV();
  const date = new Date();
  const expirationTimeStamp = expiration
    ? expiration * 1000 : date.getTime() + (20 * 24 * 60 * 60 * 1000);
  date.setTime(expirationTimeStamp);

  axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  document.cookie = `rpg_temp_token=${token};expires=${date.toGMTString()};${['production', 'development'].includes(process.env.VUE_APP_ENV) ? domain : null}`;
  document.cookie = `rpg_temp_token_type=${tokenType};expires=${date.toGMTString()};${['production', 'development'].includes(process.env.VUE_APP_ENV) ? domain : null}`;
  document.cookie = `rpg_temp_token_is_link=${isLink};expires=${date.toGMTString()};${['production', 'development'].includes(process.env.VUE_APP_ENV) ? domain : null}`;
}
